export const _en = {
    group: {
        label: "Group"
    },
    course: {
        label: "Training course"
    },
    capacity: {
        label: "Capacity"
    },
    quadDigit: {
        label: "Quad index"
    }
};


export const _fr = {
    group: {
        label: "Groupe"
    },
    course: {
        label: "Stage"
    },
    capacity: {
        label: "Capacité du groupe"
    },
    quadDigit: {
        label: "Groupe QUAD"
    }
};